var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.authChecked && _vm.showSideMenu)?_c('side-menu'):_vm._e(),_c('v-app-bar',{attrs:{"clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"app":"","color":"#000000","dark":""}},[_c('header-item')],1),_c('v-main',[_c('v-container',{class:_vm.$route.name === 'login' ||
        _vm.$route.name === 'send_email' ||
        _vm.$route.name === 'password_reset'
          ? 'wide'
          : '',attrs:{"fluid":""}},[_c('snackbar'),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }